'use client';

import {
  useInfiniteQuery,
  type InfiniteData,
  type UseInfiniteQueryResult,
} from '@tanstack/react-query';
import { getPublicClips, type ClipsResponse, type GetClipsParams } from 'services/clips';

export type ClipsQueryParams = Omit<GetClipsParams, 'page'>;

interface UseGetClipsOptions {
  enabled?: boolean;
}

const useGetClips = (
  params: ClipsQueryParams = {},
  { enabled = true }: UseGetClipsOptions = {},
): UseInfiniteQueryResult<InfiniteData<ClipsResponse>> =>
  useInfiniteQuery({
    queryKey: ['clips', params],
    queryFn: ({ pageParam }) => getPublicClips({ ...params, page: pageParam }),
    initialPageParam: 0,
    getNextPageParam: (lastPage: ClipsResponse) =>
      lastPage.pageNumber + 1 < lastPage.totalPages ? lastPage.pageNumber + 1 : undefined,
    staleTime: 60000,
    refetchOnWindowFocus: false,
    enabled,
  });

export default useGetClips;
